// src/pages/agent/PendingApproval.js
// Shown when a signed-in user is not yet whitelisted as an agent.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase';
import { useAgentAuth } from '../../lib/auth';
import Logo from '../../components/Logo';

export default function PendingApproval() {
  const { user, profile } = useAgentAuth();
  const navigate = useNavigate();

  // If somehow already active (e.g. admin promoted them while open), bounce to dashboard.
  if (profile?.status === 'active') { navigate('/agent/dashboard'); return null; }

  return (
    <div style={s.page}>
      <div style={s.glow} />
      <div style={s.card}>
        <Logo />
        <div style={s.eyebrow}>Awaiting approval</div>
        <h1 style={s.h1}>You're on the <em style={s.em}>list</em>.</h1>
        <p style={s.p}>
          Thanks for signing in{user?.displayName ? `, ${user.displayName.split(' ')[0]}` : ''}. Your access request has been
          recorded. An admin will review and grant you agent access shortly. You'll receive an email once approved.
        </p>
        <p style={s.pSmall}>
          Signed in as <strong>{user?.email}</strong>.
        </p>
        <button style={s.btn} onClick={async () => { await signOut(auth); navigate('/'); }}>
          Sign out
        </button>
      </div>
    </div>
  );
}

const s = {
  page: { minHeight: '100vh', background: 'linear-gradient(135deg, #4A1220 0%, #6B1E2E 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, position: 'relative', overflow: 'hidden', fontFamily: "'DM Sans', sans-serif" },
  glow: { position: 'absolute', top: '-180px', right: '-180px', width: 480, height: 480, borderRadius: '50%', background: 'radial-gradient(circle, rgba(201,168,76,0.18) 0%, rgba(201,168,76,0) 70%)' },
  card: { position: 'relative', background: '#fff', borderRadius: 10, padding: '44px 40px', maxWidth: 480, width: '100%', boxShadow: '0 24px 64px rgba(0,0,0,0.4)', textAlign: 'center' },
  eyebrow: { fontSize: 10, fontWeight: 500, letterSpacing: '0.14em', textTransform: 'uppercase', color: '#C9A84C', borderBottom: '1px solid #C9A84C', paddingBottom: 4, display: 'inline-block', margin: '20px 0 14px' },
  h1: { fontFamily: "'Cormorant Garamond', serif", fontSize: 34, fontWeight: 500, color: '#4A1220', letterSpacing: '-0.4px', lineHeight: 1.15, margin: '0 0 14px' },
  em: { fontStyle: 'italic', color: '#6B1E2E' },
  p: { fontSize: 14, color: '#5A5A5A', lineHeight: 1.6, marginBottom: 14 },
  pSmall: { fontSize: 12, color: '#9A9A9A', marginBottom: 20 },
  btn: { background: 'transparent', border: '1px solid rgba(107,30,46,0.2)', color: '#6B1E2E', borderRadius: 4, padding: '10px 22px', fontSize: 12, cursor: 'pointer', fontFamily: "'DM Sans', sans-serif" }
};
